import React, { useState, useEffect } from "react";
import { FaVideo } from "react-icons/fa";
import { authFetch } from "../../utils";

const PTZDirectionIndicator = ({ cameraId }) => {
  const cameraApiUrl = "https://camgateway.senticnel.com/ptz";
  const [pan, setPan] = useState(0);

  useEffect(() => {
    let isMounted = true;

    const fetchStatus = async () => {
      try {
        const res = await authFetch(`${cameraApiUrl}/status/${cameraId}`);
        const data = await res.json();
        // 👇 asegúrate de que el backend devuelve { pan: number }
        if (isMounted && typeof data.pan === "number") {
          setPan(data.pan);
        }
      } catch (err) {
        console.error("Error obteniendo status:", err);
      }
    };

    fetchStatus(); // primera llamada inmediata
    const interval = setInterval(fetchStatus, 1000); // refresco cada 1s

    return () => {
      isMounted = false;
      clearInterval(interval);
    };
  }, [cameraId]);

  return (
    <div style={{ textAlign: "center", marginTop: "10px" }}>
      <FaVideo
        style={{
          fontSize: "40px",
          // -90 para alinear con la orientación inicial, para que la cámara apunte hacia arriba con 0º
          transform: `rotate(${pan - 90}deg)`,
          transition: "transform 0.2s ease"
        }}
      />
      <div>{(pan).toFixed(1)}°</div>
    </div>
  );
};

export default PTZDirectionIndicator;
